module.exports = __webpack_public_path__ + "assets/img/b15f3e5d95e6b09fb5d985ffd7eb4698.png";